<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card :title="periodoSelecionado ? `Matriz de Valores - ${periodoSelecionado.nome}` : 'Matriz de Valores de Contribuição'">

          <!-- Seleção de Período (específico desta tela) -->
          <b-row class="mb-2">
            <b-col
              md="6"
              lg="4"
            >
              <b-form-group
                label="Período de Vigência"
                label-for="v-periodo"
                class="font-weight-bold"
              >
                <v-select
                  id="v-periodo"
                  v-model="periodoSelecionado"
                  label="nome"
                  :options="periodos"
                  placeholder="Selecione o período"
                  @input="loadMatriz"
                />
              </b-form-group>
            </b-col>
            <b-col
              md="6"
              lg="4"
              class="d-flex align-items-center mt-1"
            >
              <b-button
                variant="outline-secondary"
                :to="{ name: 'mensalidades-dashboard' }"
              >
                <feather-icon icon="ChevronLeftIcon" />
                Voltar para Contribuições
              </b-button>
            </b-col>
          </b-row>

          <div v-if="periodoSelecionado">
            <div class="custom-search d-flex justify-content-start">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                :disabled="loadingSave || periodoBloqueado"
                @click="saveAll"
              >
                <feather-icon
                  icon="SaveIcon"
                  class="mr-25"
                />
                Salvar Alterações
              </b-button>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                class="ml-1"
                :disabled="loadingSave || loadingGlobal || periodoBloqueado"
                @click="gerarTodos"
              >
                <b-spinner
                  v-if="loadingGlobal"
                  small
                  class="mr-25"
                />
                <feather-icon
                  v-else
                  icon="PackageIcon"
                  class="mr-25"
                />
                Gerar para Todas as Categorias
              </b-button>
              <b-alert
                v-if="periodoBloqueado"
                variant="danger"
                show
                class="mb-1 py-1"
              >
                <div class="alert-body d-flex align-items-center">
                  <feather-icon
                    icon="LockIcon"
                    class="mr-1"
                    size="20"
                  />
                  <span>Este período está <strong>bloqueado</strong>. Não é possível alterar a matriz de valores de períodos encerrados.</span>
                </div>
              </b-alert>
            </div>

            <div class="custom-search d-flex justify-content-end">
              <b-form-group>
                <div class="d-flex align-items-center">
                  <label class="mr-1">Pesquisar</label>
                  <b-form-input
                    v-model="searchTerm"
                    placeholder="Pesquisar..."
                    type="text"
                    class="d-inline-block"
                  />
                </div>
              </b-form-group>
            </div>

            <vue-good-table
              :columns="fields"
              :rows="matriz"
              :rtl="direction"
              style-class="vgt-table striped"
              :search-options="{
                enabled: true,
                externalQuery: searchTerm
              }"
              :pagination-options="{
                enabled: true,
                perPage: 10
              }"
            >
              <template
                slot="table-row"
                slot-scope="props"
              >
                <span
                  v-if="props.column.field === 'tipoFaixaNome'"
                  class="font-weight-bolder text-primary"
                >
                  {{ props.row.tipoFaixaNome }}
                </span>

                <!-- Inputs Monetários com Cleave -->
                <span v-else-if="props.column.field === 'valor'">
                  <cleave
                    v-model="props.row.valor"
                    class="form-control text-right"
                    :options="options.number"
                    @input="val => updateRow(props.row, 'valor', val)"
                  />
                </span>

                <span v-else-if="props.column.field === 'diaVencimento'">
                  <b-form-input
                    :value="props.row.diaVencimento"
                    type="number"
                    min="1"
                    max="31"
                    class="text-center"
                    @input="val => updateRow(props.row, 'diaVencimento', Number(val))"
                  />
                </span>

                <span v-else-if="props.column.field === 'actions'">
                  <div class="d-flex align-items-center justify-content-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      v-b-tooltip.hover
                      variant="flat-primary"
                      :title="loadingActions[props.row.tipoFaixaId] ? 'Processando...' : 'Gerar Contribuições em Lote'"
                      :disabled="loadingActions[props.row.tipoFaixaId] || periodoBloqueado"
                      @click="gerarMensalidades(props.row)"
                    >
                      <b-spinner
                        v-if="loadingActions[props.row.tipoFaixaId]"
                        small
                      />
                      <feather-icon
                        v-else
                        icon="PackageIcon"
                      />
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      v-b-tooltip.hover
                      variant="flat-warning"
                      title="Corrigir Valores em Aberto"
                      :disabled="loadingActions[props.row.tipoFaixaId] || periodoBloqueado"
                      @click="corrigirValores(props.row)"
                    >
                      <feather-icon icon="RefreshCwIcon" />
                    </b-button>
                  </div>
                </span>

                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>

              <template
                slot="pagination-bottom"
                slot-scope="props"
              >
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> Showing 1 to </span>
                    <b-form-select
                      v-model="pageLength"
                      :options="[10, 20, 50, 100]"
                      class="mx-1"
                    />
                    <span class="text-nowrap">
                      of {{ props.total }} entries
                    </span>
                  </div>
                  <div>
                    <b-pagination
                      :value="1"
                      :total-rows="props.total"
                      :per-page="pageLength"
                      first-number
                      last-number
                      align="right"
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mt-1 mb-0"
                      @input="(value) => props.pageChanged({currentPage: value})"
                    >
                      <template #prev-text>
                        <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                        />
                      </template>
                      <template #next-text>
                        <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                        />
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </template>
            </vue-good-table>

            <b-alert
              variant="warning"
              show
              class="mt-2 mb-0 py-1"
            >
              <div class="alert-body d-flex align-items-center">
                <feather-icon
                  icon="AlertTriangleIcon"
                  class="mr-1"
                  size="20"
                />
                <span>As alterações são mantidas temporariamente e só serão persistidas no banco após clicar em <strong>Salvar Alterações</strong>.</span>
              </div>
            </b-alert>
          </div>

          <div
            v-else
            class="text-center py-5"
          >
            <div class="mb-2">
              <feather-icon
                icon="CalendarIcon"
                size="64"
                class="text-muted opacity-25"
              />
            </div>
            <h4 class="text-muted">
              Selecione um período
            </h4>
            <p class="text-muted">
              Selecione um período acima para visualizar e editar os valores de contribuição.
            </p>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Modal de Progresso -->
    <progress-modal
      v-model="showProgress"
      :log-id="currentLogId"
      @finished="onGenerationFinished"
    />

    <!-- Modal de Relatório de Geração -->
    <b-modal
      id="modal-relatorio-geracao"
      v-model="showReport"
      title="Relatório de Geração de Contribuições"
      size="lg"
      ok-only
      ok-title="Fechar"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <div
        v-if="currentLog"
        id="print-area"
      >
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div>
            <h4 class="mb-0">
              Resumo da Geração
            </h4>
            <small class="text-muted">Executado em: {{ formatDate(currentLog.dataHora) }}</small>
          </div>
          <div class="text-right">
            <b-badge :variant="currentLog.totalErros > 0 ? 'danger' : 'success'">
              {{ currentLog.totalErros > 0 ? 'Concluído com Erros' : 'Concluído com Sucesso' }}
            </b-badge>
          </div>
        </div>

        <b-row class="mb-2 text-center">
          <b-col cols="3">
            <div class="border rounded p-1">
              <h3 class="mb-0">
                {{ currentLog.totalRegistros }}
              </h3>
              <small class="text-muted">Total Processado</small>
            </div>
          </b-col>
          <b-col cols="3">
            <div class="border rounded p-1 text-success">
              <h3 class="mb-0">
                {{ currentLog.totalSucesso }}
              </h3>
              <small class="text-nowrap">Gerados</small>
            </div>
          </b-col>
          <b-col cols="3">
            <div class="border rounded p-1 text-warning">
              <h3 class="mb-0">
                {{ currentLog.totalIgnorados }}
              </h3>
              <small class="text-nowrap">Ignorados</small>
            </div>
          </b-col>
          <b-col cols="3">
            <div class="border rounded p-1 text-danger">
              <h3 class="mb-0">
                {{ currentLog.totalErros }}
              </h3>
              <small class="text-nowrap">Erros</small>
            </div>
          </b-col>
        </b-row>

        <h5 class="mb-1">
          Detalhamento por Registro
        </h5>
        <div
          class="table-responsive"
          style="max-height: 400px; overflow-y: auto;"
        >
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th>Nome</th>
                <th class="text-center">
                  Status
                </th>
                <th>Observação</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in currentLog.itens"
                :key="item.id"
              >
                <td>{{ item.registro.nome }}</td>
                <td class="text-center">
                  <b-badge :variant="statusVariant(item.status)">
                    {{ item.status === 'IGNORADO' ? 'IGNORADO' : item.status }}
                  </b-badge>
                </td>
                <td><small>{{ item.observacao }}</small></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <template #modal-footer="{ ok }">
        <b-button
          variant="outline-primary"
          @click="printReport"
        >
          <feather-icon
            icon="PrinterIcon"
            class="mr-50"
          />
          Imprimir
        </b-button>
        <b-button
          variant="primary"
          @click="ok()"
        >
          Fechar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BFormSelect, BPagination, BButton, BAlert, VBTooltip, BSpinner, BModal, BBadge,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
import Ripple from 'vue-ripple-directive'
import { VueGoodTable } from 'vue-good-table'
import tipoFaixaServices from '@/api/financial/tipoFaixaServices'
import periodoVigenciaServices from '@/api/financial/periodoVigenciaServices'
import valorFaixaVigenciaServices from '@/api/financial/valorFaixaVigenciaServices'
import mixinsGlobal from '@/mixins'
import ProgressModal from './components/ProgressModal.vue'

export default {
  name: 'MatrizValores',
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BPagination,
    BButton,
    BAlert,
    vSelect,
    Cleave,
    VueGoodTable,
    BSpinner,
    BModal,
    BBadge,
    ProgressModal,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      periodoSelecionado: null,
      loadingSave: false,
      loadingGlobal: false,
      loadingActions: {},
      showReport: false,
      showProgress: false,
      currentLog: null,
      currentLogId: null,
      searchTerm: '',
      pageLength: 10,
      periodos: [],
      tiposFaixa: [],
      matriz: [],
      fields: [
        { label: 'Categoria', field: 'tipoFaixaNome' },
        {
          label: 'Valor (R$)', field: 'valor', thClass: 'text-right', tdClass: 'text-right',
        },

        {
          label: 'Dia Venciment.', field: 'diaVencimento', thClass: 'text-center', tdClass: 'text-center',
        },
        {
          label: 'Ações', field: 'actions', thClass: 'text-center', tdClass: 'text-center',
        },
      ],
      options: {
        number: {
          numeral: true,
          numeralDecimalMark: ',',
          delimiter: '.',
          numeralDecimalScale: 2,
        },
      },
    }
  },
  computed: {
    direction() {
      return this.$store.state.appConfig.isRTL
    },
    periodoBloqueado() {
      return this.periodoSelecionado && this.periodoSelecionado.bloqueado
    },
  },
  mounted() {
    this.loadInitialData()
  },
  methods: {
    async loadInitialData() {
      try {
        const [resPeriodos, resTipos] = await Promise.all([
          periodoVigenciaServices.loadCombo(),
          tipoFaixaServices.loadCombo(),
        ])
        this.periodos = resPeriodos.data
        this.tiposFaixa = resTipos.data
      } catch (err) {
        this.MensagemError('Erro', 'Não foi possível carregar os dados iniciais.')
      }
    },
    async loadMatriz() {
      if (!this.periodoSelecionado) return

      try {
        const promises = this.tiposFaixa.map(tipo => valorFaixaVigenciaServices.findByTipoFaixaAndPeriodo(tipo.id, this.periodoSelecionado.id)
          .then(res => {
            const formatToCleave = val => {
              if (val === null || val === undefined) return '0,00'
              return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val)
            }
            return {
              tipoFaixaId: tipo.id,
              tipoFaixaNome: tipo.nome,
              id: res.data ? res.data.id : null,
              valor: res.data ? formatToCleave(res.data.valor) : '0,00',
              diaVencimento: res.data ? res.data.diaVencimento : 10,
            }
          }))
        this.matriz = await Promise.all(promises)
      } catch (err) {
        this.MensagemError('Erro', 'Erro ao carregar matriz de valores.')
      }
    },
    updateRow(row, field, value) {
      const item = this.matriz.find(m => m.tipoFaixaId === row.tipoFaixaId)
      if (item) {
        this.$set(item, field, value)
      }
    },
    // async saveAll() {
    //   this.loadingSave = true
    //   try {
    //     const parseValue = val => {
    //       if (typeof val === 'string') {
    //         return parseFloat(val.replace(/\./g, '').replace(',', '.'))
    //       }
    //       return val
    //     }

    //     const promises = this.matriz.map(item => {
    //       const payload = {
    //         id: item.id,
    //         tipoFaixa: { id: item.tipoFaixaId },
    //         periodoVigencia: { id: this.periodoSelecionado.id },
    //         valor: parseValue(item.valor),
    //         percentualJuros: parseValue(item.percentualJuros),
    //         percentualMulta: parseValue(item.percentualMulta),
    //         diaVencimento: item.diaVencimento,
    //       }
    //       if (item.id) {
    //         return valorFaixaVigenciaServices.update(item.id, payload)
    //       }
    //       return valorFaixaVigenciaServices.save(payload)
    //     })

    //     const results = await Promise.all(promises)
    //     results.forEach((res, index) => {
    //       if (res.data && res.data.id) {
    //         this.$set(this.matriz[index], 'id', res.data.id)
    //       }
    //     })

    //     this.showMessageSuccess('Sucesso', 'Todos os valores foram salvos com sucesso.')
    //     await this.loadMatriz()
    //   } catch (err) {
    //     this.MensagemError('Erro', 'Falha ao salvar alguns valores da matriz.')
    //   } finally {
    //     this.loadingSave = false
    //   }
    // },
    async saveAll() {
      this.loadingSave = true
      try {
        const parseValue = val => {
          if (typeof val === 'number') return val
          if (!val) return 0
          const str = String(val).trim()

          // Caso 1: Formato Brasileiro padrão (ex: "1.234,56" ou "123,45")
          if (str.includes(',')) {
            return parseFloat(str.replace(/\./g, '').replace(',', '.'))
          }

          // Caso 2: String sem vírgula, mas com ponto (ex: "1.519" ou "151.9")
          if (str.includes('.')) {
            const parts = str.split('.')
            const lastPart = parts[parts.length - 1]

            // Se a última parte tem exatamente 3 dígitos, é muito provável que o ponto seja separador de milhar (ex: "1.519")
            // No contexto de mensalidades, raramente teremos 3 casas decimais.
            if (lastPart.length === 3) {
              return parseFloat(str.replace(/\./g, ''))
            }

            // Caso contrário (ex: "151.9" ou "151.90"), tratamos o ponto como decimal (padrão JS)
            return parseFloat(str)
          }

          // Caso 3: Número limpo ou inteiro
          return parseFloat(str)
        }

        const promises = this.matriz.map(item => {
          const payload = {
            id: item.id,
            tipoFaixa: { id: item.tipoFaixaId },
            periodoVigencia: { id: this.periodoSelecionado.id },
            valor: parseValue(item.valor),
            diaVencimento: item.diaVencimento,
          }
          console.log(`Salvando Linha [${item.tipoFaixaNome}]: original="${item.valor}" -> parsed=${payload.valor}`)
          return valorFaixaVigenciaServices.save(payload)
        })

        await Promise.all(promises)
        this.showMessageSuccess('Sucesso', 'Todos os valores foram salvos com sucesso.')
        await this.loadMatriz()
      } catch (err) {
        this.MensagemError('Erro', 'Falha ao salvar alguns valores da matriz.')
      } finally {
        this.loadingSave = false
      }
    },
    gerarMensalidades(item) {
      this.$bvModal.msgBoxConfirm(`Deseja gerar as contribuições em lote para "${item.tipoFaixaNome}" no período "${this.periodoSelecionado.nome}"?`, {
        title: 'Confirmação',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: 'Sim',
        cancelTitle: 'Não',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      }).then(value => {
        if (value) {
          this.$set(this.loadingActions, item.tipoFaixaId, true)
          valorFaixaVigenciaServices.gerarMensalidadesLote(item.tipoFaixaId, this.periodoSelecionado.id)
            .then(res => {
              this.currentLogId = res.data.id
              this.showProgress = true
            })
            .catch(() => this.MensagemError('Erro', 'Falha ao processar comando.'))
            .finally(() => {
              this.$set(this.loadingActions, item.tipoFaixaId, false)
            })
        }
      })
    },
    gerarTodos() {
      this.$bvModal.msgBoxConfirm(`Deseja gerar as contribuições de TODAS as categorias no período "${this.periodoSelecionado.nome}"? Este processo será executado em segundo plano e você poderá acompanhar o progresso.`, {
        title: 'Geração Global',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: 'Sim, Gerar Tudo',
        cancelTitle: 'Cancelar',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      }).then(value => {
        if (value) {
          this.loadingGlobal = true
          valorFaixaVigenciaServices.gerarMensalidadesLoteTodos(this.periodoSelecionado.id)
            .then(res => {
              this.currentLogId = res.data.id
              this.showProgress = true
            })
            .catch(() => this.MensagemError('Erro', 'Falha ao processar comando global.'))
            .finally(() => {
              this.loadingGlobal = false
            })
        }
      })
    },
    onGenerationFinished(log) {
      this.currentLog = log
      this.showReport = true
    },
    corrigirValores(item) {
      this.$bvModal.msgBoxConfirm('Deseja atualizar os valores de todas as mensalidades em ABERTO desta categoria no período? O processo ocorrerá em segundo plano.', {
        title: 'Recalcular Valores',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'warning',
        okTitle: 'Sim, Corrigir',
        cancelTitle: 'Cancelar',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      }).then(value => {
        if (value) {
          this.$set(this.loadingActions, item.tipoFaixaId, true)
          valorFaixaVigenciaServices.corrigirValoresLote(item.tipoFaixaId, this.periodoSelecionado.id)
            .then(res => {
              this.currentLogId = res.data.id
              this.showProgress = true
            })
            .catch(() => this.MensagemError('Erro', 'Falha ao processar comando.'))
            .finally(() => {
              this.$set(this.loadingActions, item.tipoFaixaId, false)
            })
        }
      })
    },
    statusVariant(status) {
      if (status === 'SUCESSO') return 'light-success'
      if (status === 'IGNORADO') return 'light-warning'
      return 'light-danger'
    },
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleString('pt-BR')
    },
    printReport() {
      const printContents = document.getElementById('print-area').innerHTML
      const originalContents = document.body.innerHTML
      document.body.innerHTML = `
        <div style="padding: 20px; font-family: sans-serif;">
          <h2 style="text-align: center; color: #7367f0;">Relatório de Geração de Contribuições</h2>
          <hr/>
          ${printContents}
        </div>
      `
      window.print()
      document.body.innerHTML = originalContents
      window.location.reload() // Necessário para restaurar os eventos do Vue após window.print manual
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';

.custom-search {
  margin-bottom: 1rem;

  label {
    margin-bottom: 0;
    font-weight: 500;
  }
}
</style>
